import { defineMessages } from 'react-intl';

export const plpKeyFeaturesMessages = defineMessages({
  material: {
    id: `plp.keyFeatures.material`,
    defaultMessage: 'Material',
  },
  color: {
    id: `plp.keyFeatures.color`,
    defaultMessage: 'Color',
  },
  lugType: {
    id: `plp.keyFeatures.lugType`,
    defaultMessage: 'Lug type',
  },
  lug: {
    id: `plp.keyFeatures.lug`,
    defaultMessage: 'Lug',
  },
  buckleType: {
    id: `plp.keyFeatures.buckleType`,
    defaultMessage: 'Buckle type',
  },
  buckleSize: {
    id: `plp.keyFeatures.buckleSize`,
    defaultMessage: 'Buckle size',
  },
});
